import axios from 'axios'
import moment from 'moment'
import Utils from '../../utils/utils'
import CONST from '../../utils/const'
import config from '../../config'

export async function getPeopleAttributeList(condition = {}) {
  let response = {}

  let scenicAreaId = condition.scenicAreaId // 沒有景區id則是全部
  let scenicAreaIdQuery = Utils.isEmptyObject(scenicAreaId) || scenicAreaId < 0 ? '' : `?scenicAreaId=${scenicAreaId}` 
  let startTime = condition.startTime? encodeURIComponent(moment(condition.startTime).format().split('+')[0]) : null //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? `&startTime=${startTime}` : ''
  let endTime = condition.endTime?  encodeURIComponent(moment(condition.endTime).format().split('+')[0]) : null//2022-08-05T14:41:00+08:00 移除時區(+之後)
  let endTimeQuery = endTime ? `&endtime=${endTime}` : ''
  //沒有起訖時間則預設為今日

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}PeopleAttribute/GetPeopleAttributeList${scenicAreaIdQuery}${startTimeQuery}${endTimeQuery}`)

  } catch (err) {
    console.error('iisi GetPeopleAttributeList: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response

}

export async function getPeopleAttributeListPerHour(condition = {}) {
  let response = {}

  // let scenicAreaId = condition.scenicAreaId // 沒有景區id則是全部
  // let scenicAreaIdQuery = Utils.isEmptyObject(scenicAreaId) || scenicAreaId < 0 ? '?scenicAreaId=' : `?scenicAreaId=${scenicAreaId}` 
  let scenicAreaIdQuery = "";
  if(condition.scenicAreaId.length > 1) {
    const query = condition.scenicAreaId.map((scenicAreaId) => `scenicAreaIds=${scenicAreaId}`).join('&');
     scenicAreaIdQuery =  "?"+query;

  }else{
    scenicAreaIdQuery = `?scenicAreaIds=${condition.scenicAreaId}`
  }
 
  let startTime = condition.startTime? encodeURIComponent(moment(condition.startTime).format().split('+')[0]) : null //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? `&startTime=${startTime}` : ''
  let endTime = condition.endTime?  encodeURIComponent(moment(condition.endTime).format().split('+')[0]) : null//2022-08-05T14:41:00+08:00 移除時區(+之後)
  let endTimeQuery = endTime ? `&endtime=${endTime}` : ''
  //沒有起訖時間則預設為今日

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}PeopleAttribute/GetPeopleAttributeListPerHour${scenicAreaIdQuery}${startTimeQuery}${endTimeQuery}`)

  } catch (err) {
    console.error('iisi getPeopleAttributeListPerHour: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response

}

export async function getPeopleAttributeListPerDay(condition = {}) {
  let response = {}

  let scenicAreaId = condition.scenicAreaId // 沒有景區id則是全部
  let scenicAreaIdQuery = Utils.isEmptyObject(scenicAreaId) || scenicAreaId < 0 ? '?scenicAreaIds=' : `?scenicAreaIds=${scenicAreaId}` 
  let startTime = condition.startTime? encodeURIComponent(moment(condition.startTime).format().split('+')[0]) : null //2022-08-05T14:41:00+08:00 移除時區(+之後)
  let startTimeQuery = startTime ? `&startTime=${startTime}` : ''
  let endTime = condition.endTime?  encodeURIComponent(moment(condition.endTime).format().split('+')[0]) : null//2022-08-05T14:41:00+08:00 移除時區(+之後)
  let endTimeQuery = endTime ? `&endtime=${endTime}` : ''
  //沒有起訖時間則預設為今日

  try {
    response = await axios.get(`${config.eastCoastMonitorApi()}PeopleAttribute/GetPeopleAttributeListPerDay${scenicAreaIdQuery}${startTimeQuery}${endTimeQuery}`)

  } catch (err) {
    console.error('iisi GetPeopleAttributeListPerDay: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response

}